import React from 'react';
import { motion } from 'framer-motion';

const brands = ['KOKO AI', 'NextEra', 'The Career Space', 'FitSync', 'Aahar AI'];

function TrustBar() {
  return (
    <section
      aria-label="Trusted by"
      className="relative bg-paper py-12 md:py-16"
    >
      <div className="section-wrap">
        <p className="meta-label text-center">Trusted by builders & teams</p>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-16"
        >
          {brands.map((b, i) => (
            <motion.span
              key={b}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.45, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-xl font-bold uppercase tracking-[-0.01em] text-ink/55 transition-colors hover:text-ink md:text-2xl"
            >
              {b}
            </motion.span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default TrustBar;
